import { EDIT_PROGRAM_FORM } from '@/constants/forms';
import IdGeneratorService from '@/services/id-generator.service';
import type { ReactNode } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import People from './People';
import Rules from './Rules';
import { InputController } from '@/components/inputs/InputController';
import TextInput from '@/components/inputs/TextInput';

interface Group {
	name: string;
	description: string;
	peopleCount: number;
}

type Rule = {
	icon: ReactNode;
	title: string;
	value: string;
	onClick: () => void;
};

type Props = {
	rules: Rule[];
	groups: Group[];
};

const EditProgramForm = (props: Props) => {
	const { rules, groups } = props;
	const formName = new IdGeneratorService(EDIT_PROGRAM_FORM).formId;
	const methods = useForm();
	const { control } = methods;

	// TODO: Proper Implementation
	return (
		<FormProvider {...methods}>
			<form id={formName} noValidate>
				<div className="space-y-6">
					<h1 className="text-headline-xx-large text-primary">
						Edit Program
					</h1>
					<div className="space-y-6">
						<h2 className="text-headline-medium text-neutral17">
							Program name
						</h2>
						<div className="space-y-4">
							<div className="md:w-1/2">
								<InputController id="name" control={control}>
									<TextInput label="Program name" variant="outlined" labelBgColor="bg-surface" />
								</InputController>
								<small
									id="name-help"
									className="ml-4 text-body-xx-small"
								>
									Participants will see your program name in
									the Xpress App
								</small>
							</div>
							<div className="md:w-1/2">
								<InputController id="description" control={control}>
									<TextInput label="Description" variant="outlined" labelBgColor="bg-surface" />
								</InputController>
								<small
									id="description-help"
									className="ml-4 text-body-xx-small"
								>
									People in the Xpress app will see this
									description
								</small>
							</div>
						</div>
						<div className="space-y-11">
							<div className="space-y-6">
								<h2 className="text-headline-medium text-neutral17">
									Rules
								</h2>
								<Rules rules={rules} />
							</div>
							<People groups={groups} />
						</div>
					</div>
				</div>
			</form>
		</FormProvider>
	);
};

export default EditProgramForm;
